import { render, staticRenderFns } from "./selfOperatedProductsList.vue?vue&type=template&id=c9edbf08&scoped=true"
import script from "./selfOperatedProductsList.vue?vue&type=script&lang=js"
export * from "./selfOperatedProductsList.vue?vue&type=script&lang=js"
import style0 from "./selfOperatedProductsList.vue?vue&type=style&index=0&id=c9edbf08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9edbf08",
  null
  
)

export default component.exports